import { render, staticRenderFns } from "./LoginScreen.vue?vue&type=template&id=5d3a1e6b&scoped=true"
import script from "./LoginScreen.vue?vue&type=script&lang=js"
export * from "./LoginScreen.vue?vue&type=script&lang=js"
import style0 from "./LoginScreen.vue?vue&type=style&index=0&id=5d3a1e6b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3a1e6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d3a1e6b')) {
      api.createRecord('5d3a1e6b', component.options)
    } else {
      api.reload('5d3a1e6b', component.options)
    }
    module.hot.accept("./LoginScreen.vue?vue&type=template&id=5d3a1e6b&scoped=true", function () {
      api.rerender('5d3a1e6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LoginScreen.vue"
export default component.exports